import axios from "axios";
import * as actionType from "../../constant/actionType";
export const RejectProviderInvitation = (ApiData,ipAddress) => async (dispatch) => {
      try {
        const response = await axios({
          method: 'put',
          data: ApiData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
            userip:ipAddress
          },
          url: `${actionType.environment_url}/api/RejectProviderInvitation`,
        });
        return response.data
      } catch (error) {
        return error.message
      }
    }